import { DefaultFilter } from './../lookups/default-filter/default-filter.component';
import { FakDokumentStavkaModalUpdateComponent } from './faktura/fak-dokument-stavka-modal-update.component';
import { FakDokumentStavkaView } from './faktura/fak-dokument-stavka-view';
import { FakDokumentStavka } from './faktura/fak-dokument-stavka';
import { FakDokumentView } from './faktura/fak-dokument-view';
import { FakDokumentTabsComponent } from './faktura/fak-dokument-tabs.component';
import { VrstaStavkiModalUpdateComponent } from './vrsta-stavki/vrsta-stavki-modal-update.component';
import { ColumnType, CryptoService, ModalSize, PrintType, RefreshType, TableRowColorType } from 'yt-ng-framework';
import { FormType } from 'yt-ng-framework';
import { VrstaStavkiComponent } from './vrsta-stavki/vrsta-stavki.component';
import { FakComponent } from './fak.component';
import { LookupsRoutes } from './../lookups/routes';
import { HomeComponent } from './home/home.component';
import { Routes, RouterModule } from '@angular/router';
import { Injector, NgModule } from '@angular/core';
import { VrstaStavki } from './vrsta-stavki/vrsta-stavki';
import { FakDokument } from './faktura/fak-dokument';
import { VrstaStavkiView } from './vrsta-stavki/vrsta-stavki-view';
import { CanDeactivateGuard } from 'yt-ng-framework';
import { FakVrstaTroskaComponent } from './fak-vrsta-troska/fak-vrsta-troska.component';
import { FakVrstaTroska } from './fak-vrsta-troska/fak-vrsta-troska';
import { FakVrstaTroskaModalUpdateComponent } from './fak-vrsta-troska/fak-vrsta-troska-modal-update.component';
import { TrosakDokumentTabsComponent } from './trosak/trosak-dokument-tabs.component';
import { TrosakDokument } from './trosak/trosak-dokument';
import { TrosakDokumentStavkaView } from './trosak/trosak-dokument-stavka-view';
import { TrosakDokumentView } from './trosak/trosak-dokument-view';
import { TrosakDokumentStavka } from './trosak/trosak-dokument-stavka';
import { TrosakDokumentStavkaModalUpdateComponent } from './trosak/trosak-dokument-stavka-modal-update.component';
import { RekapitulacijaTroskovaComponent } from './_reports/rekapitulacija-troskova/rekapitulacija-troskova.component';
import { ConditionType } from 'yt-ng-framework';
import { RequestType } from 'yt-ng-framework';
import { FilterWithKomitentComponent } from './_filters/filter-with-komitent.component';
import { DrzavaComponent } from '../lookups/drzava/drzava.component';
import { Drzava } from '../lookups/drzava/drzava';
import { DrzavaModalUpdateComponent } from '../lookups/drzava/drzava-modal-update.component';
import { OdabirAvansaComponent } from './faktura/odabir/odabir-avansa.component';
import { OdabirDokumentaComponent } from './faktura/odabir/odabir-dokumenta.component';
import { SpisakDokumenata } from './faktura/odabir/spisak-dokumenata';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { RekapitulacijaDokumenataComponent } from './_reports/rekapitulacija_dokumenata/rekapitulacija-dokumenata.component';
import { OdabirDokumentaV2Component } from './faktura/odabir/odabir-dokumenta-v2.component';
import { RekapitulacijaRacunaComponent } from './_reports/rekapitulacija_racuna/rekapitulacija-racuna.component';
import { SpisakIskoriscenihComponent } from './faktura/odabir/spisak-iskoriscenih.component';
import { SpisakIskoriscenih } from './faktura/odabir/spisak-iskoriscenih';
import { PoreskoOslobodjenje } from '../lookups/poresko-oslobodjenje/poresko-oslobodjenje';
import { SpisakPoreskihOslobodjenjaComponent } from './faktura/spisak-poreskih-oslobodjenja/spisak-poreskih-oslobodjenja.component';
import { FakDokumentStavkaUpdateContainer } from './faktura/fak-dokument-stavka-update-container.component';
import { FakDokumentStavkaUpdateComponent } from './faktura/fak-dokument-stavka-update.component';
import { FakDokumentStavkaIzvoz } from './faktura/izvoz/fak-dokument-stavka-izvoz';
import { FakDokumentIzvoz } from './faktura/izvoz/fak-dokument-izvoz';
import { FakDokumentIzvozView } from './faktura/izvoz/fak-dokument-izvoz-view';
import { FakDokumentStavkaIzvozView } from './faktura/izvoz/fak-dokument-stavka-izvoz-view';
import { VrstaDatumaPoreskeObavezeComponent } from './vrsta-datuma-poreske-obaveze/vrsta-datuma-poreske-obaveze.component';
import { VrstaDatumaPoreskeObaveze } from './vrsta-datuma-poreske-obaveze/vrsta-datuma-poreske-obaveze';
import { SendEdokumentComponent } from './faktura/edokument/send-edokument.component';
import { EkranskaKarticaKomitenataComponent } from './_reports/ekranska-kartica-komitenata/ekranska-kartica-komitenata.component';
import { FilterWithOrgJedComponent } from './_filters/filter-with-org-jed.component';
import { VrstaStavkiKodKupcaComponent } from './vrsta-stavki-kod-kupca/vrsta-stavki-kod-kupca.component';
import { VrstaStavkiKodKupca } from './vrsta-stavki-kod-kupca/vrsta-stavki-kod-kupca';
import { VrstaStavkiKodKupcaView } from './vrsta-stavki-kod-kupca/vrsta-stavki-kod-kupca-view';
import { VrstaStavkiKodKupcaModalUpdateComponent } from './vrsta-stavki-kod-kupca/vrsta-stavki-kod-kupca-modal-update.component';
import { FilterOnlyKomitentComponent } from './_filters/filter-only-komitent.component';
import { EkranskaKarticaKomitenataModalComponent } from './_reports/ekranska-kartica-komitenata/ekranska-kartica-komitenata-modal.component';
import { TekuceEkranskiPregledKomitenata } from './_reports/ekranska-kartica-komitenata/tekuce-ekranski-pregled-komitenata';
import { EkranskaKarticaKomitenata } from './_reports/ekranska-kartica-komitenata/ekranska-kartica-komitenata';
import { OdabirAvansaV2Component } from './faktura/odabir/odabir-avansa-v2.component';
import { SpisakDokumenataV2, SpisakDokumenataStavkeV2 } from './faktura/odabir/spisak-dokumenata-v2';
import { IzvestajONenaplacenimRacunimaComponent } from './_reports/izvestaj-o-nenaplacenim-racunima/izvestaj-o-nenaplacenim-racunima.component';
import { InstrukcijeZaPlacanjaComponent } from './faktura/odabir/instrukcije-za-placanja.component';
import { InstrukcijaZaPlacanjeByFirmaId } from './faktura/odabir/InstrukcijaZaPlacanjeByFirmaId';
import { FakDokumentUplata } from './faktura/fak-dokument-uplata/fak-dokument-uplata';
import { FakDokumentUplataView } from './faktura/fak-dokument-uplata/fak-dokument-uplata-view';
import { FakDokumentUplataModalUpdateComponent } from './faktura/fak-dokument-uplata/fak-dokument-uplata-modal-update.component';
import { KpoObrazacComponent } from './_reports/kpo-obrazac/kpo-obrazac.component';





let childrenRoutes: Routes = [
    {
        path: 'home',
        component: HomeComponent
    }
    , {
        path: 'vrstadatumaporeskeobaveze',
        component: VrstaDatumaPoreskeObavezeComponent,
        pathMatch: 'full',
        data: {
            mainList: {
                modelName: 'VrstaDatumaPoreskeObaveze',
                getName: 'get',
                getParameters: [],
                modelClass: VrstaDatumaPoreskeObaveze,
                shortModelClass: VrstaDatumaPoreskeObaveze,
                parentProperty: '',
                tableColumns: [
                    { name: 'Sifra', label: 'VRSTADATUMAPORESKEOBAVEZE.SIFRA.SINGULAR', visible: true, canHide: false, width: '10%'  }
                    , { name: 'Opis', label: 'VRSTADATUMAPORESKEOBAVEZE.OPIS.SINGULAR', visible: true, canHide: false, width: '45%' }
                ],
                sortBy: 'Opis',
                sortReverse: false,
                enableEdit: true,
                enableDelete: true,
                formType: FormType.Reactive
            },
            mainTitle: 'VrstaDatumaPoreskeObaveze',
            modalSize: ModalSize.Lg,
            refreshType: RefreshType.NoReload,
            loadOnInit: true,
            breadcrumbLabel: 'VRSTADATUMAPORESKEOBAVEZE.PLURAL'
        }
    }
    , {
        path: 'vrstastavki',
        component: VrstaStavkiComponent,
        pathMatch: 'full',
        data: {
            mainList: {
                label: 'TABLE.VRSTESTAVKIRACUNA.PLURAL',
                modelName: 'vrstastavki',
                getName: 'get',
                getParameters: [],
                modelClass: VrstaStavki,
                shortModelClass: VrstaStavkiView,
                parentProperty: '',
                tableColumns: [
                    { name: 'Sifra', label: 'VRSTASTAVKI.SIFRA.SINGULAR', visible: true, canHide: false, width: '10%'  }
                    , { name: 'Naziv', label: 'VRSTASTAVKI.OPIS.SINGULAR', visible: true, canHide: false, width: '45%' }
                    , { name: 'RobaUsluga', label: 'VRSTASTAVKI.ROBAUSLUGA.SINGULAR', visible: true, canHide: false, width: '10%' }
                    , { name: 'JedinicaMere', label: 'VRSTASTAVKI.JEDINICAMERE.SINGULAR', visible: true, canHide: false, width: '15%' }
                    , { name: 'Cena', label: 'VRSTASTAVKI.CENA.SINGULAR', visible: true, canHide: false, type: 'number', width: '20%' }
                    // , { name: 'Konto', label: 'VRSTASTAVKI.KONTO.SINGULAR', visible: true, canHide: false, width: '20%' }
                ],
                sortBy: 'Naziv',
                sortReverse: false,
                enableEdit: true,
                enableDelete: true,
                formType: FormType.Reactive
            },
            mainTitle: 'VrstaStavki',
            updateComponent: VrstaStavkiModalUpdateComponent,
            modalSize: ModalSize.Lg,
            refreshType: RefreshType.NoReload,
            loadOnInit: true,
            breadcrumbLabel: 'VRSTASTAVKI.PLURAL'
        }
    }
    , {
        path: 'vrstastavkikodkupca',
        component: VrstaStavkiKodKupcaComponent,
        pathMatch: 'full',
        data: {
            mainList: {
                label: 'TABLE.VRSTESTAVKIKODKUPCA.PLURAL',
                modelName: 'vrstastavkikodkupca',
                getName: 'get',
                getParameters: [],
                modelClass: VrstaStavkiKodKupca,
                shortModelClass: VrstaStavkiKodKupcaView,
                parentProperty: '',
                tableColumns: [
                    { name: 'VrstaStavki', label: 'VRSTASTAVKIKODKUPCA.VRSTASTAVKI.SINGULAR', visible: true, canHide: false, width: '30%'  },
                    { name: 'Komitent', label: 'VRSTASTAVKIKODKUPCA.KOMITENT.SINGULAR', visible: true, canHide: false, width: '30%' },
                    { name: 'SifraKodKomitenta', label: 'VRSTASTAVKIKODKUPCA.SIFRAKODKOMITENTA.SINGULAR', visible: true, canHide: false, width: '30%' }
                ],
                sortBy: 'Naziv',
                sortReverse: false,
                enableEdit: true,
                enableDelete: true,
                formType: FormType.Reactive,
                defaultListFilterComponent:FilterOnlyKomitentComponent,
                requestType: RequestType.POST
            },
            mainTitle: 'VrstaStavkiKodKupca',
            updateComponent: VrstaStavkiKodKupcaModalUpdateComponent,
            modalSize: ModalSize.Lg,
            refreshType: RefreshType.NoReload,
            loadOnInit: true,
            breadcrumbLabel: 'VRSTASTAVKIKODKUPCA.SINGULAR'
        }
    }
    , {
        path: 'racuni',
        component: FakDokumentTabsComponent,
        pathMatch: 'full',
        canDeactivate: [CanDeactivateGuard],
        data: {
            mainList: {
                
                userRightsModelName:'faktura',
                printName: 'stampa_racuna',
                label: 'TABLE.RACUNI.PLURAL',
                printType: PrintType.Document,
                printController: 'Report',
                modelName: 'FakDokument',
                getName: 'getByUrl',
                getParameters: [{ Name: 'url', Value: '/fak/racuni' }],
                modelClass: FakDokument,
                shortModelClass: FakDokumentView,
                parentProperty: '',                
                tableColumns: [                    
                      { name: 'BrojDokumenta', label: 'FAKDOKUMENT.BRDOK.SINGULAR', visible: true, canHide: false, width: '17%' }
                    , { name: 'Datum', label: 'FAKDOKUMENT.DATDOK.SINGULAR', type: 'ngbDate', format: 'dd.MM.yyyy', visible: true, canHide: false, width: '17%' }
                    , { name: 'Komitent', label: 'FAKDOKUMENT.KOMITENT.SINGULAR', visible: true, canHide: false, width: '17%', tooltipName: 'Komitent' }
                    , { name: 'KomitentMesto', label: 'FAKDOKUMENT.KOMITENTMESTO.SINGULAR', visible: true, width: '17%', canHide: true }
                    , { name: 'Ukupno', label: 'FAKDOKUMENT.UKUPNO.SINGULAR', type: 'number', visible: true, candHide: false, width: '17%', aligment: 'right' }
                    , { name: 'UkupnoAvansi', label: 'FAKDOKUMENT.AVANS.SIGULAR', type: 'number', visible: false, canHide: true, width: '17%', aligment: 'right'}
                    , { name: 'Izvodi', label: 'FAKDOKUMENT.UPLATE.SINGULAR', type: 'number', visible: false, canHide: true, width: '17%', aligment: 'right'}
                    , { name: 'Naplaceno', label: 'FAKDOKUMENT.NAPLACENO.SINGULAR', type: 'number', visible: true, canHide: false, width: '17%', aligment: 'right'}
                    , { name: 'ZaUplatu', label: 'FAKDOKUMENT.ZAUPLATU.SINGULAR', type: 'number', visible: true, canHide: false, width: '17%', aligment: 'right'}
                    , { name: 'ProvajderID', label: 'Provaj.', type: 'number', visible: false, width: '3%', canHide: true }
                    , {
                        name: 'StatusColor'
                        , label: 'FAKDOKUMENT.STATUSGENERICNAME.SINGULAR'
                        , type: "color-box"
                        , visible: true
                        , candHide: false
                        , width: '10%'
                        , aligment: 'center' 
                        , tooltipName: 'StatusTooltip'
                        , tooltipName2: 'Komentar'
                    },
                    {
                        name: 'VezanZaPpp',
                        label: 'FAKDOKUMENT.VEZANSAPPP.SINGULAR',
                        type: 'boolean',
                        visible: true,
                        canHide: false,
                        width: '12%',
                        aligment: 'center',
                        tooltipName: 'VezanZaPppTooltip'
                      }
                    ,{ name: 'StatusGenericName', label: '', visible: false, width: '0%'}
                     , { name: 'RokDana', label: 'FAKDOKUMENT.ROKDANA.SINGULAR', type: ColumnType.Number ,format: '1.0-0', visible: true, canHide: true, width: '15%'}

                    // , { name: 'UlaziUSumu', label: 'UlaziUSumu', type: 'bool', visible: false, width: '3%', canHide: true }
                    // , {
                    //     name: 'StatusTooltip'
                    //     , label: 'FAKDOKUMENT.STATUSGENERICNAME.SINGULAR'
                    //     , visible: true
                    //     , candHide: false
                    //     , width: '15%'
                    //     , aligment: 'center' 
                    // }
                ],
                tableColumnsSums: [
                    {
                        columns: ['Ukupno']
                        , condition: {
                            columnName: 'UlaziUSumu'
                            , conditionType: ConditionType.Equals
                            , value: true
                        }                       
                    }
                ],

                tableContextMenuItems:[
                    { Name: 'Item 1', Action: 'Ponovi', Label: 'FAKDOKUMENT.PONOVI.ACTION'}
                    , { Name: 'Item 2', Action: 'OsveziStatus', Label: 'FAKDOKUMENT.OSVEZISTATUS.ACTION'}
                    // , { Name: 'Item 3', Action: 'CancelDocument', Label: 'FAKDOKUMENT.CANCELDOCUMENT.ACTION', IsEnabledFunction: CheckContextMenuAvailability }
                    //, { Name: 'Item 3', Action: 'EvidencijaUplate', Label: 'FAKDOKUMENT.EVIDENCIJAUPLATE.ACTION' }
                    , { Name: 'Item 4', Action: 'StornoDocument', Label: 'FAKDOKUMENT.STORNODOCUMENT.ACTION', IsEnabledFunction: CheckContextMenuAvailabilityStorno}
                    , { Name: 'Item 5', Action: 'DeleteDocument', Label: 'FAKDOKUMENT.DELETEDOCUMENT.ACTION', IsEnabledFunction: CheckContextMenuAvailabilityNov }
                    // , { Name: 'Item 6', Action: 'ResendDocument', Label: 'FAKDOKUMENT.RESENDDOCUMENT.ACTION', IsEnabledFunction: CheckContextMenuAvailability }
                    , { Name: 'Item 7', Action: 'PrintDispatch', Label: 'FAKDOKUMENT.PRINTDISPATCH.ACTION'}
                    , { Name: 'Item 8', Action: 'SendEUInvoice', Label: 'FAKDOKUMENT.SENDEUINVOICE.ACTION', IsEnabledFunction: CheckContextMenuAvailabilitySend  }

                    , { Name: 'Item 9', Action: 'PonudaPredracun', Label: 'FAKDOKUMENT.PONUDAPREDRACUN.ACTION',Indicator:"racun" }
                    , { Name: 'Item 10', Action: 'Download_XML_racuna', Label: 'FAKDOKUMENT.PREUZIMANJEDOKUMENTAXML.ACTION',Indicator:"racun"}
                    , { Name: 'Item 11', Action: 'dodatnaPolja', Label: 'FAKDOKUMENT.DODATNAPOLJA.ACTION',Indicator:"racun"}
                    , { Name: 'Item 12', Action: 'PovezanoSaDokumentima', Label: 'FAKDOKUMENT.POVEZANOSADOKUMENTIMA.ACTION',Indicator:"racun"}
                    // , { Name: 'Item 7', Action: 'pdfPreview', Label: 'FAKDOKUMENT.PdfPreview.ACTION'}
                ],
                tableRowColors: [
                    {
                        ColumnName: 'StatusGenericName',
                        Condition: ConditionType.Equals,
                        Value: 'storno',
                        Color: '#777',
                        Type: TableRowColorType.Foreground
                    }
                ],
                // tableRowColors: [
                //     {
                //         ColumnName: 'Ukupno',
                //         Condition: ConditionType.GreaterThan,
                //         Value: 1000,
                //         Color: '#777'
                //     }
                // ],
                sortBy: 'ID',
                sortReverse: true,
                enableEdit: true,
                enableDelete: true,
                enablePrint: true,
                enablePrintAccountSelection:true,
                formType: 'reactive',
                closeAfterSave: false,
                detailList: [
                 
                    {
                        modelName: 'FakDokumentStavka',
                        getName: 'getByFakDokumentID',
                        label: 'TABLE.STAVKERACUNA.PLURAL',
                        getParameters: [],
                        modelClass: FakDokumentStavka,
                        shortModelClass: FakDokumentStavkaView,
                        tableColumns: [
                            //{ name: 'VrstaStavki', label: 'FAKDOKUMENTSTAVKA.VRSTASTAVKI.SINGULAR', visible:true}
                            //,{ name: 'RabatVred', label: 'FAKDOKUMENTSTAVKA.RABATVRED.SINGULAR', format: '1.2-2', aligment: 'right', type:'number', visible:true} 
                            //,{ name: 'CenaSaPDV', label: 'FAKDOKUMENTSTAVKA.CENASAPDV.SINGULAR', type: 'number', aligment: 'right'}
                            // ,{ name: 'IznosPdv', label: 'FAKDOKUMENTSTAVKA.PDV.SINGULAR', format: '1.2-2', aligment: 'right', type:'number', visible:true}   
                            { name: 'Opis', label: 'FAKDOKUMENTSTAVKA.OPIS.SINGULAR', visible: true, width: '25%' }
                            , { name: 'Kolicina', label: 'FAKDOKUMENTSTAVKA.KOLICINA.SINGULAR', type: 'number', aligment: 'right', canHide: true,width: '12%' }
                            , { name: 'JedinicaMere', label: 'FAKDOKUMENTSTAVKA.JM.SINGULAR', visible: true,width: '7%'}

// 22.08.2023
                            //                            , { name: 'Cena', label: 'FAKDOKUMENTSTAVKA.CENA.SINGULAR', format: '1.4-4', aligment: 'right', type: 'number', visible: true }
                            , { name: 'Cena', label: 'FAKDOKUMENTSTAVKA.CENA.SINGULAR', format: '1.2-2', aligment: 'right', type: 'number', visible: true ,width: '13%'}

                            , { name: 'RabatProc', label: 'FAKDOKUMENTSTAVKA.RABATPROC.SINGULAR', format: '1.2-2', aligment: 'right', type: 'number', visible: true, canHide: true,width: '7%'  }
                            , { name: 'Stopa', label: 'FAKDOKUMENTSTAVKA.STOPA.SINGULAR', type: 'number', aligment: 'right', format: '1.2-2', visible: true ,width: '7%'}
                            , { name: 'Osnovica', label: 'FAKDOKUMENTSTAVKA.OSNOVICA.SINGULAR', format: '1.2-2', aligment: 'right', type: 'number', visible: true, width: '14%' }
                            , { name: 'Ukupno', label: 'FAKDOKUMENTSTAVKA.UKUPNO.SINGULAR', format: '1.2-2', aligment: 'right', type: 'number', visible: true, width: '15%' }
                        ],
                        sortBy: 'ID',
                        sortReverse: false,
                        enableEdit: false,
                        enableDelete: false,
                        parentProperty: 'FakDokumentID',
                        updateComponent: FakDokumentStavkaModalUpdateComponent,
                        formType: 'reactive',
                        showOnFirstPage: true,
                        formControlDataName: 'fak/racunstavka',
                  }
                  , {
                    modelName: 'FakDokumentUplata',
                    getName: 'getByFakDokumentID',
                    label: 'TABLE.UPLATE.PLURAL',
                    getParameters: [],
                    modelClass: FakDokumentUplata,
                    shortModelClass: FakDokumentUplataView,
                    tableColumns: [
                      { name: 'Datum', label: 'FAKDOKUMENTUPLATA.DATUM.SINGULAR', type: 'ngbDate', format: 'dd.MM.yyyy', visible: true, canHide: false, width: '30%' }
                      , { name: 'Iznos', label: 'FAKDOKUMENTUPLATA.IZNOS.SINGULAR', format: '1.2-2', aligment: 'right', type: 'number', visible: true, width: '20%' }
                      , { name: 'BrojIzvoda', label: 'FAKDOKUMENTUPLATA.BROJIZVODA.SINGULAR', aligment: 'right', visible: true, width: '30%', get condition() { return () => hasRight('faktura', 'mozeVidetiBrojIzvoda'); } }
                      , { name: 'RedniBroj', label: 'FAKDOKUMENTUPLATA.RB.SINGULAR', format: '1.0-0', aligment: 'right', type: 'number', visible: true, width: '20%' }
                    ],
                    sortBy: 'ID',
                    sortReverse: false,
                    enableEdit: true,
                    enableDelete: true,
                    parentProperty: 'FakDokumentID',
                    refreshMainlistItem: true,
                    updateComponent: FakDokumentUplataModalUpdateComponent,
                    formType: 'reactive',
                    showOnFirstPage: true,
                    formControlDataName: 'fak/racunuplata'
                  }

                ],
                formControlDataName: 'fak/racun',
                // defaultListFilterComponent: FilterWithKomitentComponent,
                requestType: RequestType.POST
            },
            //detailList: [],
            mainTitle: 'faktura',
            updateComponent: null,
            refreshType: RefreshType.NoReload,
            loadOnInit: false,            
            breadcrumbLabel: 'FAKDOKUMENT.PLURAL'
        }
    },
    {
        path: 'fakdokument',
        component: FakDokumentTabsComponent,
        pathMatch: 'full',
        canDeactivate: [CanDeactivateGuard],
        data: {
            mainList: {
                userRightsModelName:'faktura',
                printName: 'stampa_racuna',
                printType: PrintType.Document,
                printController: 'Report',
                modelName: 'FakDokument',
                getName: 'getByUrl',
                getParameters: [{ Name: 'url', Value: '/fak/racuni' }],
                modelClass: FakDokument,
                shortModelClass: FakDokumentView,
                parentProperty: '',                
                tableColumns: [                    
                    { name: 'BrojDokumenta', label: 'FAKDOKUMENT.BRDOK.SINGULAR', visible: true, canHide: false, width: '17%' }
                    , { name: 'Datum', label: 'FAKDOKUMENT.DATDOK.SINGULAR', type: 'ngbDate', format: 'dd.MM.yyyy', visible: true, canHide: false, width: '17%' }
                    , { name: 'Komitent', label: 'FAKDOKUMENT.KOMITENT.SINGULAR', visible: true, canHide: false, width: '17%' }
                    , { name: 'KomitentMesto', label: 'FAKDOKUMENT.KOMITENTMESTO.SINGULAR', visible: true, width: '17%', canHide: true }
                    , { name: 'Ukupno', label: 'FAKDOKUMENT.UKUPNO.SINGULAR', type: 'number', visible: true, candHide: false, width: '17%' }
                    , { name: 'ProvajderID', label: 'Provaj.', type: 'number', visible: false, width: '3%', canHide: true }
                    , {
                        name: 'StatusColor'
                        , label: 'FAKDOKUMENT.STATUSGENERICNAME.SINGULAR'
                        , type: "color-box"
                        , visible: true
                        , candHide: false
                        , width: '15%'
                        , aligment: 'center' 
                        , tooltipName: 'StatusTooltip'
                    }
                    ,{ name: 'StatusGenericName', label: '', visible: false, width: '0%'}
                    // , {
                    //     name: 'StatusTooltip'
                    //     , label: 'FAKDOKUMENT.STATUSGENERICNAME.SINGULAR'
                    //     , visible: true
                    //     , candHide: false
                    //     , width: '15%'
                    //     , aligment: 'center' 
                    // }
                ],
                tableColumnsSums: [
                    {
                        columns: 'Ukupno'
                    }
                ],
                tableContextMenuItems:[
                    { Name: 'Item 1', Action: 'Ponovi', Label: 'FAKDOKUMENT.PONOVI.ACTION'}
                    , { Name: 'Item 7', Action: 'SendEUInvoice', Label: 'FAKDOKUMENT.SENDEUINVOICE.ACTION', IsEnabledFunction: CheckContextMenuAvailabilitySend }
                    , { Name: 'Item 2', Action: 'OsveziStatus', Label: 'FAKDOKUMENT.OSVEZISTATUS.ACTION' }
                    // , { Name: 'Item 3', Action: 'CancelDocument', Label: 'FAKDOKUMENT.CANCELDOCUMENT.ACTION', IsEnabledFunction: CheckContextMenuAvailability }
                    // , { Name: 'Item 4', Action: 'StornoDocument', Label: 'FAKDOKUMENT.STORNODOCUMENT.ACTION', IsEnabledFunction: CheckContextMenuAvailability }
                    , { Name: 'Item 5', Action: 'DeleteDocument', Label: 'FAKDOKUMENT.DELETEDOCUMENT.ACTION', IsEnabledFunction: CheckContextMenuAvailabilityNov }
                    , { Name: 'Item 6', Action: 'ResendDocument', Label: 'FAKDOKUMENT.RESENDDOCUMENT.ACTION', IsEnabledFunction: CheckContextMenuAvailability }


                ],
                // tableRowColors: [
                //     {
                //         ColumnName: 'Status',
                //         Condition: ConditionType.Equals,
                //         Value: 'storno',
                //         Color: '#ff595e',
                //         Type: TableRowColorType.Background
                //     }
                // ],
                sortBy: 'ID',
                sortReverse: true,
                enableEdit: true,
                enableDelete: true,
                enablePrint: true,
                enablePrintAccountSelection:true,
                formType: 'reactive',
                closeAfterSave: false,
                detailList: [
                    {
                        modelName: 'FakDokumentStavka',
                        getName: 'getByFakDokumentID',
                        getParameters: [],
                        modelClass: FakDokumentStavka,
                        shortModelClass: FakDokumentStavkaView,
                        tableColumns: [
                            //{ name: 'VrstaStavki', label: 'FAKDOKUMENTSTAVKA.VRSTASTAVKI.SINGULAR', visible:true}
                            //,{ name: 'RabatVred', label: 'FAKDOKUMENTSTAVKA.RABATVRED.SINGULAR', format: '1.2-2', aligment: 'right', type:'number', visible:true} 
                            //,{ name: 'CenaSaPDV', label: 'FAKDOKUMENTSTAVKA.CENASAPDV.SINGULAR', type: 'number', aligment: 'right'}
                            // ,{ name: 'IznosPdv', label: 'FAKDOKUMENTSTAVKA.PDV.SINGULAR', format: '1.2-2', aligment: 'right', type:'number', visible:true}   
                            { name: 'Opis', label: 'FAKDOKUMENTSTAVKA.OPIS.SINGULAR', visible: true, width: '30%' }
                            , { name: 'Kolicina', label: 'FAKDOKUMENTSTAVKA.KOLICINA.SINGULAR', type: 'number', aligment: 'right', canHide: true }
                            , { name: 'JedinicaMere', label: 'FAKDOKUMENTSTAVKA.JM.SINGULAR', visible: true}
                            , { name: 'Cena', label: 'FAKDOKUMENTSTAVKA.CENA.SINGULAR', format: '1.2-2', aligment: 'right', type: 'number', visible: true }
                            , { name: 'RabatProc', label: 'FAKDOKUMENTSTAVKA.RABATPROC.SINGULAR', format: '1.2-2', aligment: 'right', type: 'number', visible: true, canHide: true  }
                            , { name: 'Stopa', label: 'FAKDOKUMENTSTAVKA.STOPA.SINGULAR', type: 'number', aligment: 'right', format: '1.2-2', visible: true }
                            , { name: 'Osnovica', label: 'FAKDOKUMENTSTAVKA.OSNOVICA.SINGULAR', format: '1.2-2', aligment: 'right', type: 'number', visible: true, width: '15%' }
                            , { name: 'Ukupno', label: 'FAKDOKUMENTSTAVKA.UKUPNO.SINGULAR', format: '1.2-2', aligment: 'right', type: 'number', visible: true, width: '15%' }
                        ],
                        sortBy: 'ID',
                        sortReverse: false,
                        enableEdit: false,
                        enableDelete: false,
                        parentProperty: 'FakDokumentID',
                        updateComponent: FakDokumentStavkaModalUpdateComponent,
                        formType: 'reactive',
                        showOnFirstPage: true,
                        formControlDataName: 'fak/racunstavka',
                    }

                ],
                formControlDataName: 'fak/racun',
                // defaultListFilterComponent: FilterWithKomitentComponent,
                requestType: RequestType.POST
            },
            //detailList: [],
            mainTitle: 'faktura',
            updateComponent: null,
            refreshType: RefreshType.NoReload,
            loadOnInit: false,            
            breadcrumbLabel: 'FAKDOKUMENT.PLURAL'
        }
    },
    {
        path: 'ponude',
        component: FakDokumentTabsComponent,
        pathMatch: 'full',
        canDeactivate: [ CanDeactivateGuard ],
        data: {
            mainList: {
                label: 'TABLE.PONUDE.PLURAL',
                printName: 'printaj',
                modelName: 'FakDokument',
                userRightsModelName:'fak-ponuda',
                getName: 'getByUrl',
                getParameters: [ { Name: 'url', Value: '/fak/ponude' }],
                modelClass: FakDokument,
                shortModelClass: FakDokumentView,
                parentProperty: '',
                tableColumns: [
                    { name: 'BrojDokumenta', label: 'FAKDOKUMENT.BRDOK.SINGULAR', width: '20%' }
                    , { name: 'Datum', label: 'FAKDOKUMENT.DATDOK.SINGULAR', type: 'ngbDate', format: 'dd.MM.yyyy', visible: true, canHide: false, width: '20%' }
                    , { name: 'Komitent', label: 'FAKDOKUMENT.KOMITENT.SINGULAR', visible: true, canHide: false, width: '40%' }
                    , { name: 'KomitentMesto', label: 'FAKDOKUMENT.KOMITENTMESTO.SINGULAR', visible: true, width: '20%', canHide: true  }
                    , { name: 'Ukupno', label: 'FAKDOKUMENT.UKUPNO.SINGULAR', type: 'number', visible: true, candHide: false, width: '20%' }
                ],
                tableColumnsSums: [
                    {
                        columns: 'Ukupno'
                    }
                ],
                tableContextMenuItems:[
                  { Name: 'Item 1', Action: 'Ponovi', Label: 'FAKDOKUMENT.PONOVI.ACTION' },
                  { Name: 'Item 12', Action: 'PovezanoSaDokumentima', Label: 'FAKDOKUMENT.POVEZANOSADOKUMENTIMA.ACTION', Indicator: "racun" }

                ],
                sortBy: 'ID',
                sortReverse: true,
                enableEdit: true,
                enableDelete: true,
                enablePrint: true,
                formType: 'reactive',
                closeAfterSave: false,
                detailList: [
                    {
                        label: 'TABLE.PONUDESTAVKE.PLURAL',
                        modelName: 'FakDokumentStavka',
                        getName: 'getByFakDokumentID',
                        getParameters: [],
                        modelClass: FakDokumentStavka,
                        shortModelClass: FakDokumentStavkaView,
                        tableColumns: [
                            { name: 'Opis', label: 'FAKDOKUMENTSTAVKA.OPIS.SINGULAR', width: '25%' }
                            , { name: 'Kolicina', label: 'FAKDOKUMENTSTAVKA.KOLICINA.SINGULAR', type: 'number', aligment: 'right', canHide: true, width: '12%'  }
                            , { name: 'JedinicaMere', label: 'FAKDOKUMENTSTAVKA.JM.SINGULAR', visible: true, width: '7%'}

// 22.08.2023
                            // , { name: 'Cena', label: 'FAKDOKUMENTSTAVKA.CENA.SINGULAR', format: '1.4-4', aligment: 'right', type: 'number', visible: true }
                            , { name: 'Cena', label: 'FAKDOKUMENTSTAVKA.CENA.SINGULAR', format: '1.2-2', aligment: 'right', type: 'number', visible: true, width: '13%' }

                            , { name: 'RabatProc', label: 'FAKDOKUMENTSTAVKA.RABATPROC.SINGULAR', format: '1.2-2', aligment: 'right', type: 'number', visible: true, canHide: true, width: '7%'  }
                            , { name: 'Stopa', label: 'FAKDOKUMENTSTAVKA.STOPA.SINGULAR', type: 'number', aligment: 'right', format: '1.2-2', visible: true, width: '7%' }
                            , { name: 'Osnovica', label: 'FAKDOKUMENTSTAVKA.OSNOVICA.SINGULAR', format: '1.2-2', aligment: 'right', type: 'number', visible: true, width: '14%' }
                            , { name: 'Ukupno', label: 'FAKDOKUMENTSTAVKA.UKUPNO.SINGULAR', format: '1.2-2', aligment: 'right', type: 'number', visible: true, width: '15%' }
                        ],
                        sortBy: 'ID',
                        sortReverse: false,
                        enableEdit: false,
                        enableDelete: false,
                        parentProperty: 'FakDokumentID',
                        updateComponent: FakDokumentStavkaModalUpdateComponent,
                        formType: 'reactive',
                        showOnFirstPage: true,
                        formControlDataName: 'fak/ponudastavka',
                    }
                ],
                formControlDataName: 'fak/ponuda'
                // defaultListFilterComponent: FilterWithKomitentComponent,
                , requestType: RequestType.POST
            },
            mainTitle: 'ponuda',
            updateComponent: null,
            refreshType: RefreshType.NoReload,
            loadOnInit: false,
            breadcrumbLabel: 'FAKPONUDA.PLURAL'
        }
    },
    {
        path: 'predracuni',
        component: FakDokumentTabsComponent,
        pathMatch: 'full',
        canDeactivate: [ CanDeactivateGuard ],
        data: {
            mainList: {
                label: 'TABLE.PREDRACUNI.PLURAL',
                printName: 'printaj',
                modelName: 'FakDokument',
                userRightsModelName:'fak-predracun',
                getName: 'getByurl',
                getParameters: [{ Name: 'url', Value: '/fak/predracuni' }],
                modelClass: FakDokument,
                shortModelClass: FakDokumentView,
                parentProperty: '',
                tableColumns: [
                    { name: 'BrojDokumenta', label: 'FAKDOKUMENT.BRDOK.SINGULAR', width: '20%' }
                    , { name: 'Datum', label: 'FAKDOKUMENT.DATDOK.SINGULAR', type: 'ngbDate', format: 'dd.MM.yyyy', visible: true, canHide: false, width: '20%' }
                    , { name: 'Komitent', label: 'FAKDOKUMENT.KOMITENT.SINGULAR', visible: true, canHide: false, width: '40%' }
                    , { name: 'KomitentMesto', label: 'FAKDOKUMENT.KOMITENTMESTO.SINGULAR', visible: true, canHide: true, width: '20%' }
                    , { name: 'Ukupno', label: 'FAKDOKUMENT.UKUPNO.SINGULAR', type: 'number', visible: true, candHide: false, width: '20%' }
                ],
                tableColumnsSums: [
                    {
                        columns: 'Ukupno'
                    }
                ],
                tableContextMenuItems:[
                  { Name: 'Item 1', Action: 'Ponovi', Label: 'FAKDOKUMENT.PONOVI.ACTION' },
                  { Name: 'Item 9', Action: 'PonudaPredracun', Label: 'FAKDOKUMENT.PONUDAPREDRACUN.ACTION', Indicator: "racun" },
                  { Name: 'Item 12', Action: 'PovezanoSaDokumentima', Label: 'FAKDOKUMENT.POVEZANOSADOKUMENTIMA.ACTION', Indicator: "racun" }

                ],
                sortBy: 'ID',
                sortReverse: true,
                enableEdit: true,
                enableDelete: true,
                enablePrint: true,
                formType: FormType.Reactive,
                closeAfterSave: false,
                enablePrintAccountSelection: true,
                detailList: [
                    {
                        label: 'TABLE.PREDRACUNISTAVKE.PLURAL',
                        modelName: 'FakDokumentStavka',
                        getName: 'getByFakDokumentID',
                        getParameters: [],
                        modelClass: FakDokumentStavka,
                        shortModelClass: FakDokumentStavkaView,
                        tableColumns: [
                            { name: 'Opis', label: 'FAKDOKUMENTSTAVKA.OPIS.SINGULAR', width: '25%' }
                            , { name: 'Kolicina', label: 'FAKDOKUMENTSTAVKA.KOLICINA.SINGULAR', type: 'number', aligment: 'right', canHide: true, width: '12%'  }
                            , { name: 'JedinicaMere', label: 'FAKDOKUMENTSTAVKA.JM.SINGULAR', visible: true, width: '7%'}

// 22.08.2023
                            // , { name: 'Cena', label: 'FAKDOKUMENTSTAVKA.CENA.SINGULAR', format: '1.4-4', aligment: 'right', type: 'number', visible: true }
                            , { name: 'Cena', label: 'FAKDOKUMENTSTAVKA.CENA.SINGULAR', format: '1.2-2', aligment: 'right', type: 'number', visible: true, width: '13%' }

                            , { name: 'RabatProc', label: 'FAKDOKUMENTSTAVKA.RABATPROC.SINGULAR', format: '1.2-2', aligment: 'right', type: 'number', visible: true, canHide: true, width: '7%' }
                            , { name: 'Stopa', label: 'FAKDOKUMENTSTAVKA.STOPA.SINGULAR', type: 'number', aligment: 'right', format: '1.2-2', visible: true, width: '7%' }
                            , { name: 'Osnovica', label: 'FAKDOKUMENTSTAVKA.OSNOVICA.SINGULAR', format: '1.2-2', aligment: 'right', type: 'number', visible: true, width: '14%' }
                            , { name: 'Ukupno', label: 'FAKDOKUMENTSTAVKA.UKUPNO.SINGULAR', format: '1.2-2', aligment: 'right', type: 'number', visible: true, width: '15%' }
                        ],
                        sortBy: 'ID',
                        sortReverse: false,
                        enableEdit: false,
                        enableDelete: false,
                        enablePrint: false,
                        parentProperty: 'FakDokumentID',
                        updateComponent: FakDokumentStavkaModalUpdateComponent,
                        formType: FormType.Reactive,
                        showOnFirstPage: true,
                        formControlDataName: 'fak/predracunstavka',
                    }
                ],
                formControlDataName: 'fak/predracun',
                // defaultListFilterComponent: FilterWithKomitentComponent,
                requestType: RequestType.POST
            },
            mainTitle: 'predracuni',
            updateComponent: null,
            refreshType: RefreshType.NoReload,
            loadOnInit: false,
            breadcrumbLabel: 'FAKPREDRACUN.PLURAL'
        }
    },
    {
        path: 'avansni',
        component: FakDokumentTabsComponent,
        pathMatch: 'full',
        canDeactivate: [ CanDeactivateGuard ],
        data: {
            mainList: {
                label: 'TABLE.AVANSNIRACUNI.PLURAL',
                modelName: 'FakDokument',
                userRightsModelName:'fak-avansni',
                printName: 'printaj',
                getName: 'getByUrl',
                getParameters: [ { Name: 'url', Value: '/fak/avansni' }],
                modelClass: FakDokument,
                shortModelClass: FakDokumentView,
                parentProperty: '',
                tableColumns: [
                    { name: 'BrojDokumenta', label: 'FAKDOKUMENT.BRDOK.SINGULAR', width: '17%' },
                    { name: 'Datum', label: 'FAKDOKUMENT.DATDOK.SINGULAR', type: 'ngbDate', format: 'dd.MM.yyyy', visible: true, canHide: false, width: '17%' },
                    { name: 'Komitent', label: 'FAKDOKUMENT.KOMITENT.SINGULAR', visible: true, canHide: false, width: '17%' },
                    { name: 'KomitentMesto', label: 'FAKDOKUMENT.KOMITENTMESTO.SINGULAR', visible: true, canHide: true, width: '17%' },
                    { name: 'Ukupno', label: 'FAKDOKUMENT.UKUPNO.SINGULAR', type: 'number', visible: true, candHide: false, width: '17%' },                   
                    {
                      name: 'StatusColor',
                      label: 'FAKDOKUMENT.STATUSGENERICNAME.SINGULAR',
                      type: "color-box",
                      visible: true,
                      candHide: false,
                      width: '7%',
                      aligment: 'center',
                      tooltipName: 'StatusTooltip',
                    },
                    {
                        name: 'VezanZaPpp',
                        label: 'FAKDOKUMENT.VEZANSAPPP.SINGULAR',
                        type: 'boolean',
                        visible: true,
                        canHide: false,
                        width: '8%',
                        aligment: 'center',
                        tooltipName: 'VezanZaPppTooltip'
                      }
                  ],
                tableColumnsSums: [
                    {
                        columns: 'Ukupno'
                        , condition: {
                            columnName: 'UlaziUSumu'
                            , conditionType: ConditionType.Equals
                            , value: true
                        }
                    }
                ],
                tableRowColors: [
                    {
                        ColumnName: 'StatusGenericName',
                        Condition: ConditionType.Equals,
                        Value: 'storno',
                        Color: '#777',
                        Type: TableRowColorType.Foreground
                    }
                ],
                tableContextMenuItems:[
                    { Name: 'Item 1', Action: 'Ponovi', Label: 'FAKDOKUMENT.PONOVI.ACTION' }
                    , { Name: 'Item 7', Action: 'SendEUInvoice', Label: 'FAKDOKUMENT.SENDEUINVOICE.ACTION', IsEnabledFunction: CheckContextMenuAvailabilitySend }
                    , { Name: 'Item 2', Action: 'OsveziStatus', Label: 'FAKDOKUMENT.OSVEZISTATUS.ACTION' }
                  , { Name: 'Item 4', Action: 'StornoDocument', Label: 'FAKDOKUMENT.STORNODOCUMENT.ACTION', IsEnabledFunction: CheckContextMenuAvailabilityStorno }
                  , { Name: 'Item 9', Action: 'PonudaPredracun', Label: 'FAKDOKUMENT.PONUDAPREDRACUN.ACTION', Indicator: "racun" }
                  , { Name: 'Item 10', Action: 'Download_XML_racuna', Label: 'FAKDOKUMENT.PREUZIMANJEDOKUMENTAXML.ACTION', Indicator: "racun" }
                  , { Name: 'Item 11', Action: 'dodatnaPolja', Label: 'FAKDOKUMENT.DODATNAPOLJA.ACTION', Indicator: "racun" }
                  , { Name: 'Item 12', Action: 'PovezanoSaDokumentima', Label: 'FAKDOKUMENT.POVEZANOSADOKUMENTIMA.ACTION', Indicator: "racun" }
                  , { Name: 'Item 5', Action: 'DeleteDocument', Label: 'FAKDOKUMENT.DELETEDOCUMENT.ACTION', IsEnabledFunction: CheckContextMenuAvailabilityNov }
                    // , { Name: 'Item 6', Action: 'ResendDocument', Label: 'FAKDOKUMENT.RESENDDOCUMENT.ACTION', IsEnabledFunction: CheckContextMenuAvailability }
                ],
                sortBy: 'ID',
                sortReverse: true,
                enableEdit: true,
                enableDelete: true,
                enablePrint: true,
                formType: FormType.Reactive,
                closeAfterSave: false,
                detailList: [
                    {
                        label: 'TABLE.AVANSNIRACUNISTAVKE.PLURAL',
                        modelName: 'FakDokumentStavka',
                        getName: 'getByFakDokumentID',
                        getParameters: [],
                        modelClass: FakDokumentStavka,
                        shortModelClass: FakDokumentStavkaView,
                        tableColumns: [
                            { name: 'Opis', label: 'FAKDOKUMENTSTAVKA.OPIS.SINGULAR', width: '25%' }
                            , { name: 'Kolicina', label: 'FAKDOKUMENTSTAVKA.KOLICINA.SINGULAR', type: 'number', aligment: 'right', canHide: true, width: '12%'  }
                            , { name: 'JedinicaMere', label: 'FAKDOKUMENTSTAVKA.JM.SINGULAR', visible: true, width: '7%'}

// 22.08.2023
                            // , { name: 'Cena', label: 'FAKDOKUMENTSTAVKA.CENA.SINGULAR', format: '1.4-4', aligment: 'right', type: 'number', visible: true }
                            , { name: 'Cena', label: 'FAKDOKUMENTSTAVKA.CENA.SINGULAR', format: '1.2-2', aligment: 'right', type: 'number', visible: true, width: '13%' }

                            , { name: 'RabatProc', label: 'FAKDOKUMENTSTAVKA.RABATPROC.SINGULAR', format: '1.2-2', aligment: 'right', type: 'number', visible: true, canHide: true, width: '7%'  }
                            , { name: 'Stopa', label: 'FAKDOKUMENTSTAVKA.STOPA.SINGULAR', type: 'number', aligment: 'right', format: '1.2-2', visible: true, width: '7%'}
                            , { name: 'Osnovica', label: 'FAKDOKUMENTSTAVKA.OSNOVICA.SINGULAR', format: '1.2-2', aligment: 'right', type: 'number', visible: true, width: '14%' }
                            , { name: 'Ukupno', label: 'FAKDOKUMENTSTAVKA.UKUPNO.SINGULAR', format: '1.2-2', aligment: 'right', type: 'number', visible: true, width: '15%' }
                        ],
                        sortBy: 'ID',
                        sortReverse: false,
                        enableEdit: false,
                        enableDelete: false,
                        enablePrint: false,
                        parentProperty: 'FakDokumentID',
                        updateComponent: FakDokumentStavkaModalUpdateComponent,
                        formType: FormType.Reactive,
                        showOnFirstPage: true,
                        formControlDataName: 'fak/avansnistavka',
                        
                    }
                ],
                formControlDataName: 'fak/avansni',
                // defaultListFilterComponent: FilterWithKomitentComponent,
                requestType: RequestType.POST

            },
            mainTitle: 'avansni',
            updateComponent: null,
            refreshType: RefreshType.NoReload,
            loadOnInit: false,
            breadcrumbLabel: 'FAKAVANSNI.PLURAL'
        }
    }
    , {
        path: 'fakvrstatroska',
        component: FakVrstaTroskaComponent,
        pathMatch: 'full',
        data: {
            mainList: {
                label: 'TABLE.VRSTETROSKOVA.PLURAL',
                modelName: 'fakvrstatroska',
                getName: 'get',
                getParameters: [],
                modelClass: FakVrstaTroska,
                shortModelClass: FakVrstaTroska,
                parentProperty: '',
                tableColumns: [
                    { name: 'Naziv', label: 'FAKVRSTATROSKA.NAZIV.SINGULAR', visible: true, canHide: false }

                ],
                sortBy: 'Naziv',
                sortReverse: false,
                enableEdit: true,
                enableDelete: true,
                formType: FormType.Reactive
            },
            mainTitle: 'Vrste troška',
            updateComponent: FakVrstaTroskaModalUpdateComponent,
            modalSize: ModalSize.Lg,
            refreshType: RefreshType.NoReload,
            loadOnInit: true,
            breadcrumbLabel: 'FAKVRSTATROSKA.PLURAL'
        }
    }
    , {
        path: 'trosak',
        component: TrosakDokumentTabsComponent,
        pathMatch: 'full',
        canDeactivate: [CanDeactivateGuard],
        data: {
            mainList: {
                label: 'TABLE.TROSKOVI.PLURAL',
                userRightsModelName:'trosak',
                modelName: 'TrosakDokument',
                getName: 'getByUrl',
                getParameters: [{ Name: 'url', Value: '/fak/trosak' }],
                modelClass: TrosakDokument,
                shortModelClass: TrosakDokumentView,
                parentProperty: '',
                tableColumns: [
                    { name: 'BrojDokumenta', label: 'TROSAKDOKUMENT.BROJDOKUMENTA.SINGULAR', visible: true, canHide: false, width: '20%' }
                    , { name: 'Datum', label: 'TROSAKDOKUMENT.DATUM.SINGULAR', type: 'ngbDate', format: 'dd.MM.yyyy', visible: true, canHide: false, width: '15%' }
                    , { name: 'Komitent', label: 'TROSAKDOKUMENT.KOMITENT.SINGULAR', visible: true, canHide: false, width: '25%' }
                    , { name: 'KomitentMesto', label: 'TROSAKDOKUMENT.KOMITENTMESTO.SINGULAR', visible: true, canHide: true, width: '20%' }
                    , { name: 'Ukupno', label: 'TROSAKDOKUMENT.UKUPNO.SINGULAR', type: 'number', visible: true, candHide: false, width: '20%' }
                ],
                tableColumnsSums: [
                    {
                        columns: 'Ukupno'
                    }
                ],
                sortBy: 'ID',
                sortReverse: true,
                enableEdit: true,
                enableDelete: true,
                enablePrint: true,
                formType: 'reactive',
                closeAfterSave: false,
                detailList: [
                    {
                        label: 'TABLE.TROSKOVISTAVKE.PLURAL',
                        modelName: 'TrosakDokumentStavka',
                        getName: 'getByTrosakDokumentID',
                        getParameters: [],
                        modelClass: TrosakDokumentStavka,
                        shortModelClass: TrosakDokumentStavkaView,
                        tableColumns: [
                            { name: 'VrstaTroska', label: 'TROSAKDOKUMENTSTAVKA.VRSTATROSKA.SINGULAR', visible: true, width: '30%' }
                            , { name: 'OrgJed', label: 'TROSAKDOKUMENTSTAVKA.ORGJED.SINGULAR', visible:true, width: '30%' }
                            , { name: 'Iznos', label: 'TROSAKDOKUMENTSTAVKA.IZNOS.SINGULAR', format: '1.2-2', type: 'number', aligment: 'right' }

                        ],
                        sortBy: 'ID',
                        sortReverse: false,
                        enableEdit: false,
                        enableDelete: false,
                        parentProperty: 'TrosakDokumentID',
                        updateComponent: TrosakDokumentStavkaModalUpdateComponent,
                        formType: 'reactive',
                        showOnFirstPage: true,
                        defaultPropertyName: 'VrstaTroskaID',
                        formControlDataName: 'fak/Trosakstavka',
                    }
                ],
                formControlDataName: 'fak/trosak',
                defaultListFilterComponent:FilterWithKomitentComponent,
                requestType: RequestType.POST
                

            },
            //detailList: [],
            mainTitle: 'Trošak',
            updateComponent: null,
            refreshType: RefreshType.NoReload,
            loadOnInit: true,
            breadcrumbLabel: 'TROSAKDOKUMENT.PLURAL'
            
        }
    }
    , {
        path: 'rekapitulacijatroskova',
        component: RekapitulacijaTroskovaComponent,
        pathMatch: 'full',
        //canDeactivate: [CanDeactivateGuard],
        data: {
            mainList: {
                modelName: 'FakReports',
                userRightsModelName: 'rekapitulacijatroskova',
                printName: 'PrintajRekapitulacijuTroskova',
                printType: PrintType.Document,
                printController: 'Report',                
                tableColumns: [
                    { name: 'Naziv', label: 'REKAPITULACIJATROSKOVA.SINGULAR', visible: true, canHide: false }                    
                ],
            },
            mainTitle: 'Rekapitulacija troškova',            
            breadcrumbLabel: 'REKAPITULACIJATROSKOVA.SINGULAR'
        }
    }
    , {
        path: 'odabir-avansa',
        component: OdabirAvansaComponent,
        pathMatch: 'full',
        data: {
            mainList: {
                modelName: 'fakdokument',
                getName: 'getDokumenteByFakDokumentID',
                getParameters: [{Name: 'fakDokumentID', Value: '-1'}],
                modelClass: SpisakDokumenata,
                parentProperty: '',
                tableColumns: [
                    { name: 'Broj', label: 'ODABIRAVANSA.BROJ.SINGULAR', visible: true, canHide: false }
                    ,{ name: 'Datum', label: 'ODABIRAVANSA.DATUM.SINGULAR', type:'ngbDate', format:'dd.MM.yyyy', visible: true, canHide: false }
                    ,{ name: 'ObjekatNaziv', label: 'ODABIRAVANSA.OBJEKAT.SINGULAR', visible: true, canHide: false }
                    ,{ name: 'ObjekatID', label: '', visible: false, canHide: true }
                    ,{ name: 'Ukupno', label: 'ODABIRAVANSA.UKUPNO.SINGULAR', type:'number', format: '1.2-2', visible: true, canHide: false }

                ],
                tableRowColors: [
                    {
                        ColumnName: 'Checked',
                        Condition: ConditionType.Equals,
                        Value: true,
                        Color: '#777'
                    }
                ],
                sortBy: 'Broj',
                sortReverse: false,
                enableEdit: true,
                enableDelete: true,
                formType: FormType.Reactive,
                printName: 'printaj',
                defaultPropertyName: 'Broj'
                
            },
            mainTitle: 'ODABIR-AVANSA',
            modalSize: ModalSize.Lg,
            refreshType: RefreshType.Reload,
            loadOnInit: true,
            breadcrumbLabel: 'ODABIRAVANSA.PLURAL',
            updateComponent: OdabirAvansaComponent
        }
    }

    // , {
    //     path: 'odabirdokumenta',
    //     component: OdabirDokumentaComponent,
    //     pathMatch: 'full',
    //     data: {
    //         mainList: {
    //             modelName: 'odabirdokumenta',
    //             getName: 'get',
    //             getParameters: [],
    //             modelClass: FakDokument,
    //             shortModelClass: FakDokumentView,
    //             parentProperty: '',
    //             tableColumns: [],
    //             sortBy: 'BrojDokumenta',
    //             sortReverse: false,
    //             enableEdit: true,
    //             enableDelete: true,
    //             formType: FormType.Reactive,
    //             printName: 'printaj',
    //             defaultPropertyName: 'BrojDokumenta',                
    //         },
    //         mainTitle: 'ODABIR DOKUMENTA',
    //         modalSize: ModalSize.Lg,
    //         refreshType: RefreshType.Reload,
    //         loadOnInit: true,
    //         breadcrumbLabel: 'ODABIRDOKUMENTA.PLURAL',
    //         updateComponent: OdabirDokumentaComponent
    //     }
    // }
    
    , {
        path: 'rekapitulacijadokumenata',
        component: RekapitulacijaDokumenataComponent,
        pathMatch: 'full',
        data: {
            mainList: {
                modelName: 'FakReports',
                userRightsModelName: 'rekapitulacijadokumenata',
                printName: 'PrintajRekapitulacijuDokumenata',
                tableColumns: [
                    { name: 'Naziv', label: 'REKAPITULACIJA.SINGULAR', visible: true, canHide: false }                    
                ],
            },
            mainTitle: 'Rekapitulacija',            
            breadcrumbLabel: 'REKAPITULACIJADOKUMENATA.SINGULAR'
        }
    }

    , {
        path: 'odabirdokumenata',
        component: OdabirDokumentaV2Component,
        pathMatch: 'full',
        data: {
            mainList: {
                modelName: 'fakdokument',
                getName: 'getDokumenteByFakDokumentID',
                getParameters: [{Name: 'fakDokumentID', Value: '-1'}],
                modelClass: SpisakDokumenata,
                parentProperty: '',
                tableColumns: [
                    { name: 'Broj', label: 'ODABIRAVANSA.BROJ.SINGULAR', visible: true, canHide: false, width: "20%" }
                    ,{ name: 'Datum', label: 'ODABIRAVANSA.DATUM.SINGULAR', type:'ngbDate', format:'dd.MM.yyyy', visible: true, canHide: false, width: "15%" }
                    ,{ name: 'ObjekatNaziv', label: 'ODABIRAVANSA.OBJEKAT.SINGULAR', visible: true, canHide: false , width: "25%"}
                    ,{ name: 'ObjekatID', label: '', visible: false, canHide: true }
                    ,{ name: 'Ukupno', label: 'ODABIRAVANSA.UKUPNO.SINGULAR', type:'number', format: '1.2-2', visible: true, canHide: false , width: "20%"}

                ],
                tableRowColors: [
                    {
                        ColumnName: 'Checked',
                        Condition: ConditionType.Equals,
                        Value: true,
                        Color: '#777'
                    }
                ],
                sortBy: 'Broj',
                sortReverse: true,
                enableEdit: true,
                enableDelete: true,
                formType: FormType.Reactive,
                printName: 'printaj',
                defaultPropertyName: 'Broj'                
            },
            mainTitle: 'ODABIR DOKUMENATA',
            modalSize: ModalSize.Lg,
            refreshType: RefreshType.Reload,
            loadOnInit: true,
            breadcrumbLabel: 'ODABIRDOKUMENTA.PLURAL',
            updateComponent: OdabirDokumentaV2Component
        }
    }
    , {
        path: 'rekapitulacijaracuna',
        component: RekapitulacijaRacunaComponent,
        pathMatch: 'full',
        data: {
            mainList: {
                modelName: 'FakReports',
                userRightsModelName: 'rekapitulacijaracuna',
                printName: 'PrintajRekapitulacijuRacuna',
                tableColumns: [
                    { name: 'Naziv', label: 'REKAPITULACIJARACUNA.SINGULAR', visible: true, canHide: false }                    
                ],
            },
            mainTitle: 'Rekapitulacija računa',            
            breadcrumbLabel: 'REKAPITULACIJARACUNA.SINGULAR'
        }
    }
    , {
        path: 'iskoriscen-dokument',
        component: SpisakIskoriscenihComponent,
        pathMatch: 'full',
        data: {
            mainList: {
                modelName: 'fakdokument',
                getName: 'getDokumenteByFakDokumentID',
                getParameters: [{Name: 'fakDokumentID', Value: '-1'}],
                modelClass: SpisakIskoriscenih,
                parentProperty: '',
                tableColumns: [
                    { name: 'Broj', label: 'SPISAKISKORISCENIH.BROJ.SINGULAR', visible: true, canHide: false }
                    ,{ name: 'Datum', label: 'SPISAKISKORISCENIH.DATUM.SINGULAR', type:'ngbDate', format:'dd.MM.yyyy', visible: true, canHide: false }
                    ,{ name: 'ObjekatNaziv', label: 'SPISAKISKORISCENIH.OBJEKAT.SINGULAR', visible: true, canHide: false }
                    ,{ name: 'ObjekatID', label: '', visible: false, canHide: true }
                    ,{ name: 'Iznos', label: 'SPISAKISKORISCENIH.IZNOS.SINGULAR', type:'number', format: '1.2-2', visible: true, canHide: false }

                ],
                tableRowColors: [
                    {
                        ColumnName: 'Checked',
                        Condition: ConditionType.Equals,
                        Value: true,
                        Color: '#777'
                    }
                ],
                sortBy: 'Broj',
                sortReverse: true,
                enableEdit: true,
                enableDelete: true,
                formType: FormType.Reactive,
                printName: 'printaj',
                defaultPropertyName: 'Broj'                
            },
            mainTitle: 'SPISAK ISKORIŠĆENIH',
            modalSize: ModalSize.Lg,
            refreshType: RefreshType.Reload,
            loadOnInit: true,
            breadcrumbLabel: 'SPISAKISKORISCENIH.PLURAL',
            updateComponent: SpisakIskoriscenihComponent
        }
    }
    , {
        path: 'spisak-poreskih-oslobodjenja',
        component: SpisakPoreskihOslobodjenjaComponent,
        pathMatch: 'full',
        data: {
            mainList: {
                modelName: 'poreskooslobodjenje',
                getName: 'get',
                modelClass: PoreskoOslobodjenje,
                parentProperty: '',
                tableColumns: [
                    { name: 'Naziv', label: 'PORESKOOSLOBODJENJE.NAZIV.SINGULAR', visible: true, canHide: false }
                   
                ],
                sortBy: 'Naziv',
                sortReverse: true,
                enableEdit: true,
                enableDelete: true,
                formType: FormType.Reactive,
                printName: 'printaj',
                defaultPropertyName: 'Naziv'                
            },
            mainTitle: 'SPISAK PORESKIH OSLOBOĐENJA',
            modalSize: ModalSize.Lg,
            refreshType: RefreshType.Reload,
            loadOnInit: true,
            breadcrumbLabel: 'PORESKOOSLOBODJENJE.PLURAL',
            updateComponent: SpisakPoreskihOslobodjenjaComponent
        }
    }
    // , {
    //     path: 'stavkaracuna',
    //     component: FakDokumentStavkaUpdateContainer,
    //     pathMatch: 'full',
    //     data: {
    //         mainList: {
    //             modelName: 'FakDokumentStavka',
    //             getName: 'getByFakDokumentID',
    //             modelClass: FakDokumentStavka,
    //             parentProperty: '',
    //             tableColumns: [
    //                 { name: 'Opis', label: 'FAKDOKUMENTSTAVKA.OPIS.SINGULAR', visible: true, width: '30%' }
    //                 , { name: 'Kolicina', label: 'FAKDOKUMENTSTAVKA.KOLICINA.SINGULAR', type: 'number', aligment: 'right' }
    //                 , { name: 'JedinicaMere', label: 'FAKDOKUMENTSTAVKA.JM.SINGULAR', visible: true}
    //                 , { name: 'Cena', label: 'FAKDOKUMENTSTAVKA.CENA.SINGULAR', format: '1.2-2', aligment: 'right', type: 'number', visible: true }
    //                 , { name: 'RabatProc', label: 'FAKDOKUMENTSTAVKA.RABATPROC.SINGULAR', format: '1.2-2', aligment: 'right', type: 'number', visible: true }
    //                 , { name: 'Stopa', label: 'FAKDOKUMENTSTAVKA.STOPA.SINGULAR', type: 'number', aligment: 'right', format: '1.2-2', visible: true }
    //                 , { name: 'Osnovica', label: 'FAKDOKUMENTSTAVKA.OSNOVICA.SINGULAR', format: '1.2-2', aligment: 'right', type: 'number', visible: true, width: '15%' }
    //                 , { name: 'Ukupno', label: 'FAKDOKUMENTSTAVKA.UKUPNO.SINGULAR', format: '1.2-2', aligment: 'right', type: 'number', visible: true, width: '15%' }
    //             ],
    //             sortBy: 'ID',
    //             sortReverse: false,
    //             enableEdit: false,
    //             enableDelete: false,
    //             formType: FormType.Reactive,
    //         },
    //         mainTitle: 'Stavka',
    //         modalSize: ModalSize.Lg,
    //         refreshType: RefreshType.Reload,
    //         loadOnInit: true,
    //         breadcrumbLabel: 'FAKDOKUMENTSTAVKA.PLURAL',
    //         updateComponent: FakDokumentStavkaUpdateComponent
    //     }
    // }
    , {
        path: 'knjiznaodobrenja',
        component: FakDokumentTabsComponent,
        pathMatch: 'full',
        canDeactivate: [CanDeactivateGuard],
        data: {
            mainList: {
                label: 'TABLE.KNJIZNOODOBRENJE.PLURAL',
                printName: 'stampa_racuna',
                printType: PrintType.Document,
                printController: 'Report',
                modelName: 'FakDokument',
                userRightsModelName:'knjizno-odobrenje',
                getName: 'getByUrl',
                getParameters: [{ Name: 'url', Value: '/fak/KnjiznaOdobrenja' }],
                modelClass: FakDokument,
                shortModelClass: FakDokumentView,
                parentProperty: '',                
                tableColumns: [                    
                    { name: 'BrojDokumenta', label: 'FAKDOKUMENT.BRDOK.SINGULAR', visible: true, canHide: false, width: '17%' }
                    , { name: 'Datum', label: 'FAKDOKUMENT.DATDOK.SINGULAR', type: 'ngbDate', format: 'dd.MM.yyyy', visible: true, canHide: false, width: '17%' }
                    , { name: 'Komitent', label: 'FAKDOKUMENT.KOMITENT.SINGULAR', visible: true, canHide: false, width: '17%' }
                    , { name: 'KomitentMesto', label: 'FAKDOKUMENT.KOMITENTMESTO.SINGULAR', visible: true, canHide: false, width: '17%' }
                    , { name: 'Ukupno', label: 'FAKDOKUMENT.UKUPNO.SINGULAR', type: 'number', visible: true, candHide: false, width: '17%' }
                    // , { name: 'StatusGenericName', label: 'FAKDOKUMENT.STATUSGENERICNAME.SINGULAR', visible: true, candHide: false, width: '15%' }
                    , {
                        name: 'StatusColor'
                        , label: 'FAKDOKUMENT.STATUSGENERICNAME.SINGULAR'
                        , type: "color-box"
                        , visible: true
                        , candHide: false
                        , width: '8%'
                        , aligment: 'center' 
                        , tooltipName: 'StatusTooltip'
                    },
                    {
                        name: 'VezanZaPpp',
                        label: 'FAKDOKUMENT.VEZANSAPPP.SINGULAR',
                        type: 'boolean',
                        visible: true,
                        canHide: false,
                        width: '7%',
                        aligment: 'center',
                        tooltipName: 'VezanZaPppTooltip'
                      }    
                ],
                tableColumnsSums: [
                    {
                        columns: 'Ukupno'
                        , condition: {
                            columnName: 'UlaziUSumu'
                            , conditionType: ConditionType.Equals
                            , value: true
                        }
                    },
                ],
                tableRowColors: [
                    {
                        ColumnName: 'StatusGenericName',
                        Condition: ConditionType.Equals,
                        Value: 'storno',
                        Color: '#777',
                        Type: TableRowColorType.Foreground
                    }
                ],
                tableContextMenuItems:[
                    { Name: 'Item 1', Action: 'Ponovi', Label: 'FAKDOKUMENT.PONOVI.ACTION' }
                    , { Name: 'Item 7', Action: 'SendEUInvoice', Label: 'FAKDOKUMENT.SENDEUINVOICE.ACTION', IsEnabledFunction: CheckContextMenuAvailabilitySend }
                    , { Name: 'Item 2', Action: 'OsveziStatus', Label: 'FAKDOKUMENT.OSVEZISTATUS.ACTION' }
                  , { Name: 'Item 4', Action: 'StornoDocument', Label: 'FAKDOKUMENT.STORNODOCUMENT.ACTION', IsEnabledFunction: CheckContextMenuAvailabilityStorno }
                  , { Name: 'Item 10', Action: 'Download_XML_racuna', Label: 'FAKDOKUMENT.PREUZIMANJEDOKUMENTAXML.ACTION', Indicator: "racun" }
                  , { Name: 'Item 11', Action: 'dodatnaPolja', Label: 'FAKDOKUMENT.DODATNAPOLJA.ACTION', Indicator: "racun" }
                  , { Name: 'Item 5', Action: 'DeleteDocument', Label: 'FAKDOKUMENT.DELETEDOCUMENT.ACTION', IsEnabledFunction: CheckContextMenuAvailabilityNov }
                    // , { Name: 'Item 6', Action: 'ResendDocument', Label: 'FAKDOKUMENT.RESENDDOCUMENT.ACTION', IsEnabledFunction: CheckContextMenuAvailability }
                ],
               
                sortBy: 'ID',
                sortReverse: true,
                enableEdit: true,
                enableDelete: true,
                enablePrint: true,
                enablePrintAccountSelection:true,
                formType: 'reactive',
                closeAfterSave: false,
                detailList: [
                    {
                        label: 'TABLE.KNJIZNOODOBRENJESTAVKE.PLURAL',
                        modelName: 'FakDokumentStavka',
                        getName: 'getByFakDokumentID',
                        getParameters: [],
                        modelClass: FakDokumentStavka,
                        shortModelClass: FakDokumentStavkaView,
                        tableColumns: [
                            { name: 'Opis', label: 'FAKDOKUMENTSTAVKA.OPIS.SINGULAR', visible: true, width: '30%' }
                            , { name: 'Kolicina', label: 'FAKDOKUMENTSTAVKA.KOLICINA.SINGULAR', type: 'number', aligment: 'right' }
                            , { name: 'JedinicaMere', label: 'FAKDOKUMENTSTAVKA.JM.SINGULAR', visible: true}

// 22.08.2023
                            // , { name: 'Cena', label: 'FAKDOKUMENTSTAVKA.CENA.SINGULAR', format: '1.4-4', aligment: 'right', type: 'number', visible: true }
                            , { name: 'Cena', label: 'FAKDOKUMENTSTAVKA.CENA.SINGULAR', format: '1.2-2', aligment: 'right', type: 'number', visible: true }

                            , { name: 'Stopa', label: 'FAKDOKUMENTSTAVKA.STOPA.SINGULAR', type: 'number', aligment: 'right', format: '1.2-2', visible: true }
                            , { name: 'Osnovica', label: 'FAKDOKUMENTSTAVKA.OSNOVICA.SINGULAR', format: '1.2-2', aligment: 'right', type: 'number', visible: true, width: '15%' }
                            , { name: 'Ukupno', label: 'FAKDOKUMENTSTAVKA.UKUPNO.SINGULAR', format: '1.2-2', aligment: 'right', type: 'number', visible: true, width: '15%' }
                        ],
                        sortBy: 'ID',
                        sortReverse: false,
                        enableEdit: false,
                        enableDelete: false,
                        parentProperty: 'FakDokumentID',
                        updateComponent: FakDokumentStavkaModalUpdateComponent,
                        formType: 'reactive',
                        showOnFirstPage: true,
                        formControlDataName: 'fak/KnjiznaOdobrenjastavka',
                    }
                ],
                formControlDataName: 'fak/KnjiznaOdobrenja',
                // defaultListFilterComponent: FilterWithKomitentComponent,
                requestType: RequestType.POST
            },
            //detailList: [],
            mainTitle: 'knjizno-odobrenje',
            updateComponent: null,
            refreshType: RefreshType.NoReload,
            loadOnInit: false,            
            breadcrumbLabel: 'FAKKNJIZNOODOBRENJE.PLURAL'
        }
    }
    , {
        path: 'knjiznazaduzenja',
        component: FakDokumentTabsComponent,
        pathMatch: 'full',
        canDeactivate: [CanDeactivateGuard],
        data: {
            mainList: {
                label: 'TABLE.KNJIZNOZADUZENJE.PLURAL',
                printName: 'stampa_racuna',
                printType: PrintType.Document,
                printController: 'Report',
                modelName: 'FakDokument',
                userRightsModelName:'knjizno-zaduzenje',
                getName: 'getByUrl',
                getParameters: [{ Name: 'url', Value: '/fak/KnjiznaZaduzenja' }],
                modelClass: FakDokument,
                shortModelClass: FakDokumentView,
                parentProperty: '',                
                tableColumns: [                    
                    { name: 'BrojDokumenta', label: 'FAKDOKUMENT.BRDOK.SINGULAR', visible: true, canHide: false, width: '17%' }
                    , { name: 'Datum', label: 'FAKDOKUMENT.DATDOK.SINGULAR', type: 'ngbDate', format: 'dd.MM.yyyy', visible: true, canHide: false, width: '17%' }
                    , { name: 'Komitent', label: 'FAKDOKUMENT.KOMITENT.SINGULAR', visible: true, canHide: false, width: '17%' }
                    , { name: 'KomitentMesto', label: 'FAKDOKUMENT.KOMITENTMESTO.SINGULAR', visible: true, canHide: false, width: '17%' }
                    , { name: 'Ukupno', label: 'FAKDOKUMENT.UKUPNO.SINGULAR', type: 'number', visible: true, candHide: false, width: '17%' }
                    // , { name: 'StatusGenericName', label: 'FAKDOKUMENT.STATUSGENERICNAME.SINGULAR', visible: true, candHide: false, width: '15%' }
                    , {
                        name: 'StatusColor'
                        , label: 'FAKDOKUMENT.STATUSGENERICNAME.SINGULAR'
                        , type: "color-box"
                        , visible: true
                        , candHide: false
                        , width: '8%'
                        , aligment: 'center' 
                        , tooltipName: 'StatusTooltip'
                    },
                    {
                        name: 'VezanZaPpp',
                        label: 'FAKDOKUMENT.VEZANSAPPP.SINGULAR',
                        type: 'boolean',
                        visible: true,
                        canHide: false,
                        width: '7%',
                        aligment: 'center',
                        tooltipName: 'VezanZaPppTooltip'
                      }
                ],
                tableColumnsSums: [
                    {
                        columns: 'Ukupno'
                        , condition: {
                            columnName: 'UlaziUSumu'
                            , conditionType: ConditionType.Equals
                            , value: true
                        }
                    }
                ],
                tableRowColors: [
                    {
                        ColumnName: 'StatusGenericName',
                        Condition: ConditionType.Equals,
                        Value: 'storno',
                        Color: '#777',
                        Type: TableRowColorType.Foreground
                    }
                ],
                tableContextMenuItems:[
                    { Name: 'Item 1', Action: 'Ponovi', Label: 'FAKDOKUMENT.PONOVI.ACTION' }
                    , { Name: 'Item 7', Action: 'SendEUInvoice', Label: 'FAKDOKUMENT.SENDEUINVOICE.ACTION', IsEnabledFunction: CheckContextMenuAvailabilitySend }
                    , { Name: 'Item 2', Action: 'OsveziStatus', Label: 'FAKDOKUMENT.OSVEZISTATUS.ACTION' }
                    , { Name: 'Item 4', Action: 'StornoDocument', Label: 'FAKDOKUMENT.STORNODOCUMENT.ACTION', IsEnabledFunction: CheckContextMenuAvailabilityStorno }
                    , { Name: 'Item 5', Action: 'DeleteDocument', Label: 'FAKDOKUMENT.DELETEDOCUMENT.ACTION', IsEnabledFunction: CheckContextMenuAvailabilityNov }
                    // , { Name: 'Item 6', Action: 'ResendDocument', Label: 'FAKDOKUMENT.RESENDDOCUMENT.ACTION', IsEnabledFunction: CheckContextMenuAvailability }
                  , { Name: 'Item 10', Action: 'Download_XML_racuna', Label: 'FAKDOKUMENT.PREUZIMANJEDOKUMENTAXML.ACTION', Indicator: "racun" }
                  , { Name: 'Item 11', Action: 'dodatnaPolja', Label: 'FAKDOKUMENT.DODATNAPOLJA.ACTION', Indicator: "racun" }

                ],
               
                sortBy: 'ID',
                sortReverse: true,
                enableEdit: true,
                enableDelete: true,
                enablePrint: true,
                enablePrintAccountSelection:true,
                formType: 'reactive',
                closeAfterSave: false,
                detailList: [
                    {
                        label: 'TABLE.KNJIZNOZADUZENJESTAVKE.PLURAL',
                        modelName: 'FakDokumentStavka',
                        getName: 'getByFakDokumentID',
                        getParameters: [],
                        modelClass: FakDokumentStavka,
                        shortModelClass: FakDokumentStavkaView,
                        tableColumns: [
                            { name: 'Opis', label: 'FAKDOKUMENTSTAVKA.OPIS.SINGULAR', visible: true, width: '30%' }
                            , { name: 'Kolicina', label: 'FAKDOKUMENTSTAVKA.KOLICINA.SINGULAR', type: 'number', aligment: 'right' }
                            , { name: 'JedinicaMere', label: 'FAKDOKUMENTSTAVKA.JM.SINGULAR', visible: true}

// 22.08.2023
                            // , { name: 'Cena', label: 'FAKDOKUMENTSTAVKA.CENA.SINGULAR', format: '1.4-4', aligment: 'right', type: 'number', visible: true }
                            , { name: 'Cena', label: 'FAKDOKUMENTSTAVKA.CENA.SINGULAR', format: '1.2-2', aligment: 'right', type: 'number', visible: true }

                            , { name: 'Stopa', label: 'FAKDOKUMENTSTAVKA.STOPA.SINGULAR', type: 'number', aligment: 'right', format: '1.2-2', visible: true }
                            , { name: 'Osnovica', label: 'FAKDOKUMENTSTAVKA.OSNOVICA.SINGULAR', format: '1.2-2', aligment: 'right', type: 'number', visible: true, width: '15%' }
                            , { name: 'Ukupno', label: 'FAKDOKUMENTSTAVKA.UKUPNO.SINGULAR', format: '1.2-2', aligment: 'right', type: 'number', visible: true, width: '15%' }
                        ],
                        sortBy: 'ID',
                        sortReverse: false,
                        enableEdit: false,
                        enableDelete: false,
                        parentProperty: 'FakDokumentID',
                        updateComponent: FakDokumentStavkaModalUpdateComponent,
                        formType: 'reactive',
                        showOnFirstPage: true,
                        formControlDataName: 'fak/KnjiznaZaduzenjastavka',

                    }
                ],
                formControlDataName: 'fak/KnjiznaZaduzenja',
                // defaultListFilterComponent: FilterWithKomitentComponent,
                requestType: RequestType.POST
            },
            //detailList: [],
            mainTitle: 'knjizno-zaduzenje',
            updateComponent: null,
            refreshType: RefreshType.NoReload,
            loadOnInit: false,            
            breadcrumbLabel: 'FAKKNJIZNOZADUZENJE.PLURAL'
        }
    }
    , {
        path: 'izvozniracuni',
        component: FakDokumentTabsComponent,
        pathMatch: 'full',
        canDeactivate: [CanDeactivateGuard],
        data: {
            mainList: {
                label: 'TABLE.IZVOZNIRACUNI.PLURAL',
                printName: 'stampa_ino_racuna',
                printType: PrintType.Document,
                printController: 'Report',
                modelName: 'FakDokumentIzvoz',
                userRightsModelName:'faktura-izvozna',
                getName: 'getByUrl',
                getParameters: [{ Name: 'url', Value: '/fak/izvozniracuni' }],
                modelClass: FakDokumentIzvoz,
                shortModelClass: FakDokumentIzvozView,
                parentProperty: '',
                defaultPropertyName: 'BrojDokumenta',                
                tableColumns: [
                    { name: 'ID', label: 'FAKDOKUMENT.ID.SINGULAR', visible: false, canHide: true, width: '17%' }                                        
                    , { name: 'BrojDokumenta', label: 'FAKDOKUMENT.BRDOK.SINGULAR', visible: true, canHide: false, width: '17%' }
                    , { name: 'Datum', label: 'FAKDOKUMENT.DATDOK.SINGULAR', type: 'ngbDate', format: 'dd.MM.yyyy', visible: true, canHide: false, width: '17%' }
                    , { name: 'Komitent', label: 'FAKDOKUMENT.KOMITENT.SINGULAR', visible: true, canHide: false, width: '17%' }
                    , { name: 'KomitentMesto', label: 'FAKDOKUMENT.KOMITENTMESTO.SINGULAR', visible: true, width: '17%', canHide: true }
                    , { name: 'Valuta', label: 'FAKDOKUMENTIZVOZ.VALUTA.SINGULAR', visible: true, candHide: false, width: '17%' }
                    , { name: 'Kurs', label: 'FAKDOKUMENTIZVOZ.KURS.SINGULAR', type: 'number', format: '1.2-2', visible: true, candHide: false, width: '17%' }
                    , { name: 'UkupnoDevizno', label: 'FAKDOKUMENTSTAVKAIZVOZ.OSNOVICAUVALUTI.SINGULAR', type: 'number', format: '1.2-2', visible: true, candHide: false, width: '17%' }
                    , { name: 'Ukupno', label: 'FAKDOKUMENT.UKUPNO.SINGULAR', type: 'number', format: '1.2-2', visible: true, candHide: false, width: '17%' }
                    // , { name: 'StatusGenericName', label: 'FAKDOKUMENT.STATUSGENERICNAME.SINGULAR', visible: true, candHide: false, width: '15%' }
                    // , {
                    //     name: 'StatusColor'
                    //     , label: 'FAKDOKUMENT.STATUSGENERICNAME.SINGULAR'
                    //     , type: "color-box"
                    //     , visible: true
                    //     , candHide: false
                    //     , width: '15%'
                    //     , aligment: 'center' 
                    //     , tooltipName: 'StatusTooltip'
                    // }
                ],
                tableColumnsSums: [
                    {
                        columns: ['UkupnoDevizno','Ukupno']
                    }
                ],
                tableContextMenuItems:[
                  { Name: 'Item 1', Action: 'Ponovi', Label: 'FAKDOKUMENT.PONOVI.ACTION' },
                  { Name: 'Item 10', Action: 'Download_XML_racuna', Label: 'FAKDOKUMENT.PREUZIMANJEDOKUMENTAXML.ACTION', Indicator: "racun" },
                  { Name: 'Item 12', Action: 'PovezanoSaDokumentima', Label: 'FAKDOKUMENT.POVEZANOSADOKUMENTIMA.ACTION', Indicator: "racun" }

                ],
                sortBy: 'ID',
                sortReverse: true,
                enableEdit: true,
                enableDelete: true,
                enablePrint: true,
                enablePrintAccountSelection:true,
                formType: 'reactive',
                closeAfterSave: false,
                detailList: [
                    {
                        label: 'TABLE.IZVOZNIRACUNISTAVKE.PLURAL',
                        modelName: 'FakDokumentStavkaIzvoz',
                        getName: 'getByFakDokumentID',
                        getParameters: [],
                        modelClass: FakDokumentStavkaIzvoz,
                        shortModelClass: FakDokumentStavkaIzvozView,
                        tableColumns: [
                             { name: 'Opis', label: 'FAKDOKUMENTSTAVKA.OPIS.SINGULAR', visible: true, width: '30%' }
                            , { name: 'Kolicina', label: 'FAKDOKUMENTSTAVKA.KOLICINA.SINGULAR', type: 'number', aligment: 'right', canHide: true, width: '10%'  }
                            , { name: 'JedinicaMere', label: 'FAKDOKUMENTSTAVKA.JM.SINGULAR', visible: true, width: '5%' }
                            , { name: 'CenaUValuti', label: 'FAKDOKUMENTSTAVKAIZVOZ.CENAUVALUTI.SINGULAR', format: '1.2-2', aligment: 'right', type: 'number', visible: true, width: '10%'  }

// 22.08.2023
                            // , { name: 'Cena', label: 'FAKDOKUMENTSTAVKAIZVOZ.CENA.SINGULAR', format: '1.4-4', aligment: 'right', type: 'number', visible: true, width: '12%'  }
                            , { name: 'Cena', label: 'FAKDOKUMENTSTAVKAIZVOZ.CENA.SINGULAR', format: '1.2-2', aligment: 'right', type: 'number', visible: true, width: '12%'  }

                            , { name: 'RabatProc', label: 'FAKDOKUMENTSTAVKA.RABATPROC.SINGULAR', format: '1.2-2', aligment: 'right', type: 'number', visible: true, canHide: true, width: '8%' }
                            , { name: 'OsnovicaStavkeUValuti', label: 'FAKDOKUMENTSTAVKAIZVOZ.OSNOVICAUVALUTI.SINGULAR', format: '1.2-2', aligment: 'right', type: 'number', visible: true, width: '10%' }
                            , { name: 'Ukupno', label: 'FAKDOKUMENTSTAVKA.UKUPNO.SINGULAR', format: '1.2-2', aligment: 'right', type: 'number', visible: true, width: '15%' }

                        ],
                        sortBy: 'ID',
                        sortReverse: false,
                        enableEdit: false,
                        enableDelete: false,
                        parentProperty: 'FakDokumentID',
                        updateComponent: FakDokumentStavkaModalUpdateComponent,
                        formType: 'reactive',
                        showOnFirstPage: true,
                        formControlDataName: 'fak/izvozniracunstavka',
                    }
                ],
                columnClass: 'col-md-6',
                formControlDataName: 'fak/izvozniracun',
                // defaultListFilterComponent: FilterWithKomitentComponent,
                requestType: RequestType.POST
            },
            mainTitle: 'izvozni računi',
            updateComponent: null,
            refreshType: RefreshType.NoReload,
            loadOnInit: false,            
            breadcrumbLabel: 'FAKDOKUMENTIZVOZ.PLURAL'
        }
    }
    , {
        path: 'send-edokument',
        component: SendEdokumentComponent,
        pathMatch: 'full',
        data: {
            mainList: {
                modelName: 'fakdokument',
                getName: 'getDokumenteByFakDokumentID',
                getParameters: [{Name: 'fakDokumentID', Value: '-1'}],
                parentProperty: '',
                tableColumns: [
                    { name: 'fileName', label: 'EDOKUMENT.ATTACHMENT.DOCUMENTNAME', visible: true, canHide: false }
                    // ,{ name: 'Path', label: 'EDOKUMENT.ATTACHMENT.DOKUMENTPATH', visible: true, canHide: false }
                    
                ],
                tableRowColors: [],
                sortBy: '',
                sortReverse: true,
                enableEdit: true,
                enableDelete: true,
                formType: FormType.Reactive,
                printName: 'printaj',
                defaultPropertyName: ''                
            },
            mainTitle: 'SLANJE E-DOKUMENATA',
            modalSize: ModalSize.Lg,
            refreshType: RefreshType.Reload,
            loadOnInit: true,
            breadcrumbLabel: 'SENDEDOKUMENT.PLURAL',
            updateComponent: SendEdokumentComponent
        }
    }
    , {
        path: 'ekranskakarticakomitenata',
        component: EkranskaKarticaKomitenataComponent,
        pathMatch: 'full',
        data: {
            mainList: {
                printName: 'stampa_kartice_komitenta',
                printType: PrintType.Document,
                printController: 'Report',
                label: 'TABLE.EKRANSKAKARTICAKOMITENATA.PLURAL',
                showCheckBoxes: false, 
                editIcon: 'fas fa-eye',
                modelName: 'FakReports',
                getName: 'EkranskiPregledStanjaKomitenataGet',
                userRightsModelName: 'ekranskakarticakomitenata',
                modelClass: EkranskaKarticaKomitenata,
                getParameters: [],
                parentProperty: '',
                tableColumns: [
                    { name: 'Komitent', label: 'EKRANSKAKARTICAKOMITENATA.KOMITENT.SINGULAR', visible: true, canHide: false },
                    { name: 'Mesto', label: 'EKRANSKAKARTICAKOMITENATA.MESTO.SINGULAR', visible: false, canHide: true },
                    { name: 'Pib', label: 'EKRANSKAKARTICAKOMITENATA.PIB.SINGULAR', visible: false, canHide: true },
                    { name: 'Email', label: 'EKRANSKAKARTICAKOMITENATA.EMAIL.SINGULAR', visible: false, canHide: true,width: '150px' },
                    { name: 'Telefon', label: 'EKRANSKAKARTICAKOMITENATA.TELEFON.SINGULAR', visible: false, canHide: true ,width: '150px'},
                    { name: 'DonosDuguje', label: 'EKRANSKAKARTICAKOMITENATA.DONOSDUGUJE.SINGULAR', visible: true, canHide: false, type: 'number', aligment: 'right',format: '1.2-2', width: '150px' },
                    { name: 'DonosPotrazuje', label: 'EKRANSKAKARTICAKOMITENATA.DONOSPOTRAZUJE.SINGULAR', visible: true, canHide: false, type: 'number', aligment: 'right', format: '1.2-2', width: '150px' },
                    { name: 'DonosUkupno', label: 'EKRANSKAKARTICAKOMITENATA.DONOSUKUPNO.SINGULAR', visible: true, canHide: false, type: 'number', aligment: 'right', format: '1.2-2', width: '150px' },
                    { name: 'TekuceDuguje', label: 'EKRANSKAKARTICAKOMITENATA.TEKUCEDUGUJE.SINGULAR', visible: true, canHide: false, type: 'number', aligment: 'right', format: '1.2-2', width: '150px' },
                    { name: 'TekucePotrazuje', label: 'EKRANSKAKARTICAKOMITENATA.TEKUCEPOTRAZUJE.SINGULAR', visible: true, canHide: false, type: 'number', aligment: 'right', format: '1.2-2', width: '150px' },
                    { name: 'TekuceUkupno', label: 'EKRANSKAKARTICAKOMITENATA.TEKUCEUKUPNO.SINGULAR', visible: true, canHide: false, type: 'number', aligment: 'right', format: '1.2-2', width: '150px' },
                    { name: 'UkupnoDuguje', label: 'EKRANSKAKARTICAKOMITENATA.UKUPNODUGUJE.SINGULAR', visible: true, canHide: false, type: 'number', aligment: 'right', format: '1.2-2', width: '150px' },
                    { name: 'UkupnoPotrazuje', label: 'EKRANSKAKARTICAKOMITENATA.UKUPNOPOTRAZUJE.SINGULAR', visible: true, canHide: false, type: 'number', aligment: 'right', format: '1.2-2', width: '150px' },
                    { name: 'Ukupno', label: 'EKRANSKAKARTICAKOMITENATA.UKUPNO.SINGULAR', visible: true, canHide: false, type: 'number', aligment: 'right', format: '1.2-2', width: '150px' },
                    // ,{ name: 'Path', label: 'EDOKUMENT.ATTACHMENT.DOKUMENTPATH', visible: true, canHide: false }
                    
                ], 
                tableColumnsSums: [
                    {
                        columns: 'DonosDuguje, DonosPotrazuje, DonosUkupno, TekuceDuguje, TekucePotrazuje, TekuceUkupno, UkupnoDuguje, UkupnoPotrazuje, Ukupno',
                    }
                ],
                tableRowColors: [],
                sortBy: '',
                sortReverse: true,
                enableEdit: true,
                enableDelete: true,
                formType: FormType.Reactive,
                // printName: 'printaj',
                defaultPropertyName: '' ,
                defaultListFilterComponent: FilterWithOrgJedComponent,
                

                
                requestType: RequestType.POST         
            },
            mainTitle: 'Ekranska kartica komitenata',
            
            modalSize: ModalSize.Xl,
            // refreshType: RefreshType.Reload,
             loadOnInit: true,
             breadcrumbLabel: 'EKRANSKAKARTICAKOMITENATA.SINGULAR',
             updateComponent: EkranskaKarticaKomitenataModalComponent
            
        }
    }
    , {
        path: 'odabir-avansa-v2',
        component: OdabirAvansaV2Component,
        pathMatch: 'full',
        data: {
            mainList: {
                modelName: 'fakdokument',
                getName: 'getDokumenteByFakDokumentID',
                getParameters: [{Name: 'fakDokumentID', Value: '-1'}],
                modelClass: SpisakDokumenataV2,
                parentProperty: '',
                tableColumns: [
                    // { name: 'IsExpand', label: 'ODABIRAVANSA.EXPAND.SINGULAR', visible: true, canHide: false }
                    { name: 'Broj', label: 'ODABIRAVANSA.BROJ.SINGULAR', visible: true, canHide: false }
                    ,{ name: 'Datum', label: 'ODABIRAVANSA.DATUM.SINGULAR', type:'ngbDate', format:'dd.MM.yyyy', visible: true, canHide: false }
                    ,{ name: 'ObjekatNaziv', label: 'ODABIRAVANSA.OBJEKAT.SINGULAR', visible: true, canHide: false }
                    // ,{ name: 'ObjekatID', label: '', visible: false, canHide: true }
                    ,{ name: 'Ukupno', label: 'ODABIRAVANSA.UKUPNO.SINGULAR', type:'number', format: '1.2-2', visible: true, canHide: false }

                ],
                tableRowColors: [
                    {
                        ColumnName: 'Checked',
                        Condition: ConditionType.Equals,
                        Value: true,
                        Color: '#777'
                    }
                ],
                // getName2: 'getStavkeByDokumentID',
                // modelClass2 : SpisakDokumenataStavkeV2,
                // table2Columns: [
                //     { name: 'Opis', label: 'ODABIRAVANSA.OPIS.SINGULAR', visible: true, canHide: false }
                //     ,{ name: 'Stopa', label: 'ODABIRAVANSA.STOPA.SINGULAR', type:'number', format: '1.2-2', visible: true, canHide: false }
                //     ,{ name: 'Osnovica', label: 'ODABIRAVANSA.UKUPNO.SINGULAR', type:'number', format: '1.2-2', visible: true, canHide: false }
                //     ,{ name: 'Iskorisceno', label: 'ODABIRAVANSA.ISKORISCENO.SINGULAR', type:'number', format: '1.2-2', visible: true, canHide: false }

                // ],
                sortBy: 'Broj',
                sortReverse: false,
                enableEdit: true,
                enableDelete: true,
                formType: FormType.Reactive,
                printName: 'printaj',
                defaultPropertyName: 'Broj'
                
            },
            mainTitle: 'ODABIR-AVANSA-V2',
            modalSize: 'xl',
            refreshType: RefreshType.Reload,
            loadOnInit: true,
            breadcrumbLabel: 'ODABIRAVANSAV2.PLURAL',
            updateComponent: OdabirAvansaV2Component
        }
    }
    , {
        path: 'instrukcije-za-placanje',
        component: InstrukcijeZaPlacanjaComponent,
        pathMatch: 'full',
        data: {
            mainList: {
                modelName: 'fakdokumentizvoz',
                getName: 'GetByFirmaID',
                getParameters: [],
                modelClass: InstrukcijaZaPlacanjeByFirmaId,
                parentProperty: '',
                tableColumns: [
                    { name: 'FirmaZrc', label: 'INSTRUKCIJEZAPLACANJE.ZIRORACUN.SINGULAR', visible: true, canHide: false, width:'30%' }
                    ,{ name: 'Instrukcija', label: 'INSTRUKCIJEZAPLACANJE.INSTRUKCIJA.SINGULAR', visible: true, canHide: false, width: '50%' }
 
                ],
                // tableRowColors: [
                //     {
                //         ColumnName: 'Checked',
                //         Condition: ConditionType.Equals,
                //         Value: true,
                //         Color: '#777'
                //     }
                // ],
                sortBy: 'FirmaZrc',
                sortReverse: true,
                enableEdit: true,
                enableDelete: true,
                formType: FormType.Reactive,
                printName: 'printaj',
                defaultPropertyName: 'FirmaZrc'                
            },
            mainTitle: 'SPISAK INSTRUKCIJA',
            modalSize: ModalSize.Lg,
            refreshType: RefreshType.Reload,
            loadOnInit: true,
            breadcrumbLabel: 'INSTRUKCIJEZAPLACANJE.PLURAL',
            updateComponent: InstrukcijeZaPlacanjaComponent
        }
  }
  , {
    path: 'kpoobrazac',
    component: KpoObrazacComponent,
    pathMatch: 'full',
    data: {
      mainList: {
        modelName: 'FakReports',
        userRightsModelName: 'kpoobrazac',
        printName: 'PrintajKpoObrazac',
        printType: PrintType.List,
        printController: 'Report',
        tableColumns: [
          { name: 'Naziv', label: 'KPOOBRAZAC.SINGULAR', visible: true, canHide: false }
        ]
      },
      mainTitle: 'KPO Obrazac',
      breadcrumbLabel: 'KPOOBRAZAC.SINGULAR'
    }
  }
    

    , {
        path: 'izvestajonenaplacenimracunima',
        component: IzvestajONenaplacenimRacunimaComponent,
        pathMatch: 'full',
        data: {
            mainList: {
                modelName: 'FakReports',
                userRightsModelName: 'izvestajonenaplacenimracunima',
                printName: 'PrintajIzvestajONenaplacenimRacunima',
                printType: PrintType.Document,
                printController: 'Report',
                tableColumns: [
                    { name: 'Naziv', label: 'IZVESTAJONENAPLACENIMRACUNIMA.SINGULAR', visible: true, canHide: false }
                ],
            },
            mainTitle: 'Izveštaj o nenaplaćenim računima',            
            breadcrumbLabel: 'IZVESTAJONENAPLACENIMRACUNIMA.SINGULAR'
        }
    }

]

childrenRoutes = childrenRoutes.concat(LookupsRoutes);

const routes: Routes = [
    {
        path: '',
        component: FakComponent,
        children: childrenRoutes
    }

]
@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class FakRoutingModule {}

export function CheckContextMenuAvailability(item: FakDokumentView){
    return item.ProvajderID == 1 || item.ProvajderID == 2 || item.ProvajderID == 3 || item.ProvajderID == 4;
}
export function CheckContextMenuAvailabilityStorno(item: FakDokumentView){
    return (item.ProvajderID == 1 || item.ProvajderID == 2 || item.ProvajderID == 3 || item.ProvajderID == 4) && (item.StatusGenericName != "storno" && item.StatusGenericName != "sending");
}
export function CheckContextMenuAvailabilityUplate(item: FakDokumentView) {
  return item.ProvajderID == -1
    || item.ProvajderID == 0
    || ((item.ProvajderID == 1 || item.ProvajderID == 2 || item.ProvajderID == 3 || item.ProvajderID == 4)
      && (item.StatusGenericName != "storno"
        && item.StatusGenericName != "sending"
        && item.StatusGenericName != "unknown"
        && item.StatusGenericName != "new"
        && item.StatusGenericName != "rejected"
      )
    )
    || item.VezanZaPpp;
}

export function hasRight(model: string, action: string): boolean {
  const encrypted = sessionStorage.getItem('yt-user-rights');
  if (!encrypted) return false;

  const userRightsData = CryptoService.Decrypt(encrypted);
  if (!userRightsData || !userRightsData.Values[model]) return false;

  return userRightsData.Values[model][action];
}

export function CheckContextMenuAvailabilityNov(item: FakDokumentView){
    return (item.ProvajderID == 1 || item.ProvajderID == 2 || item.ProvajderID == 3 || item.ProvajderID == 4) && (item.StatusGenericName == "new");
 
}
export function CheckContextMenuAvailabilitySend(item: FakDokumentView){
    return (item.StatusGenericName == "unknown" || item.StatusGenericName == "");
 
}
export function CheckContextMenuAvailabilityCancel(item: FakDokumentView){
    return (item.ProvajderID == 1 || item.ProvajderID == 2 || item.ProvajderID == 3 || item.ProvajderID == 4) 
    && (item.StatusGenericName == "mistake" || item.StatusGenericName == "new");
}

